import { ArrowLeft } from 'ethena-icons';
import { HTMLAttributes } from 'react';
import css from './BackButton.module.scss';

export const BackButton = ({
  children,
  className,
  onClick,
  ...rest
}: HTMLAttributes<HTMLButtonElement>) => (
  <button className={css.backButton} color="black" onClick={onClick} {...rest}>
    <ArrowLeft className={css.icon} height={20} width={20} />
    {children || 'Back'}
  </button>
);
